<div class="period-sums"
  [class.open]="isVisible">
  @if (actualHours !== undefined) {
    <div>
      <span translate="shared.time.actual"></span><b>{{actualHours | formatNumber}}h</b>
    </div>
  }
  <div>
    <span translate="shared.time.planned"></span><b>{{plannedHours | formatNumber}}h</b>
  </div>
</div>
